import styled from "styled-components"
import theme from "../Theme"
import ClipboardButton from "react-clipboard.js"

export const Button = styled.button`
  display: ${props => (props.block ? "block" : "inline-block")};
  width: ${props => (props.block ? "100%" : "auto")};
  font-weight: 400;
  line-height: 1.25;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: .5rem 1rem;
  font-size: 1rem;
  border-radius: ${props => props.theme.buttonRadius};
  transition: all .2s;

  &:disabled {
    opacity: 0.25;
    cursor: not-allowed;
  }
`

Button.defaultProps = { theme, block: false, outline: false }

export const PrimaryButton = Button.extend`
  color: ${props =>
    props.outline ? props.theme.primary : props.theme.primaryText};
  background-color: ${props =>
    props.outline ? "transparent" : props.theme.primary};
  border-color: ${props => props.theme.primaryOutline};
  &:hover {
    color: ${props => props.theme.primaryText};
    background-color: ${props => props.theme.primaryHover};
    border-color: ${props => props.theme.primaryHover};
  }
`

export const SecondaryButton = Button.extend`
  color: ${props =>
    props.outline ? props.theme.secondary : props.theme.secondaryText};
  background-color: ${props =>
    props.outline ? "transparent" : props.theme.secondary};
  border-color: ${props => props.theme.secondaryOutline};
  &:hover {
    color: ${props => props.theme.secondaryText};
    background-color: ${props => props.theme.secondaryHover};
    border-color: ${props => props.theme.secondaryHover};
  }
`

export const SecondaryClipboardButton = styled(ClipboardButton)`
  display: ${props => (props.block ? "block" : "inline-block")};
  width: ${props => (props.block ? "100%" : "auto")};
  font-weight: 400;
  line-height: 1.25;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: .5rem 1rem;
  font-size: 1rem;
  border-radius: ${props => props.theme.buttonRadius};
  transition: all .2s;

  &:disabled {
    opacity: 0.25;
    cursor: not-allowed;
  }
  
  color: ${props =>
    props.outline ? props.theme.secondary : props.theme.secondaryText};
  background-color: ${props =>
    props.outline ? "transparent" : props.theme.secondary};
  border-color: ${props => props.theme.secondaryOutline};
  &:hover {
    color: ${props => props.theme.secondaryText};
    background-color: ${props => props.theme.secondaryHover};
    border-color: ${props => props.theme.secondaryHover};
  }
`

export const SuccessButton = Button.extend`
  color: ${props =>
    props.outline ? props.theme.success : props.theme.successText};
  background-color: ${props =>
    props.outline ? "transparent" : props.theme.success};
  border-color: ${props => props.theme.successOutline};
  &:hover {
    color: ${props => props.theme.successText};
    background-color: ${props => props.theme.successHover};
    border-color: ${props => props.theme.successHover};
  }
`

export const InfoButton = Button.extend`
  color: ${props => (props.outline ? props.theme.info : props.theme.infoText)};
  background-color: ${props =>
    props.outline ? "transparent" : props.theme.info};
  border-color: ${props => props.theme.infoOutline};
  &:hover {
    color: ${props => props.theme.infoText};
    background-color: ${props => props.theme.infoHover};
    border-color: ${props => props.theme.infoHover};
  }
`

export const WarningButton = Button.extend`
  color: ${props =>
    props.outline ? props.theme.warning : props.theme.warningText};
  background-color: ${props =>
    props.outline ? "transparent" : props.theme.warning};
  border-color: ${props => props.theme.warningOutline};
  &:hover {
    color: ${props => props.theme.warningText};
    background-color: ${props => props.theme.warningHover};
    border-color: ${props => props.theme.warningHover};
  }
`

export const DangerButton = Button.extend`
  color: ${props =>
    props.outline ? props.theme.danger : props.theme.dangerText};
  background-color: ${props =>
    props.outline ? "transparent" : props.theme.danger};
  border-color: ${props => props.theme.dangerOutline};
  &:hover {
    color: ${props => props.theme.dangerText};
    background-color: ${props => props.theme.dangerHover};
    border-color: ${props => props.theme.dangerHover};
  }
`

export const LinkButton = Button.extend`
  color: ${props => (props.outline ? props.theme.link : props.theme.linkText)};
  background-color: ${props =>
    props.outline ? "transparent" : props.theme.link};
  border-color: ${props => props.theme.linkOutline};
  &:hover {
    color: ${props => props.theme.linkText};
    background-color: ${props => props.theme.linkHover};
    border-color: ${props => props.theme.linkHover};
  }
`



// WEBPACK FOOTER //
// ./src/UI/Buttons/index.js